'use client'

import { useEffect } from 'react'
import { useAuth, useUser } from '@clerk/nextjs'
import { syncClerkUserWithSanity } from '@/lib/user-actions'

export default function BureauSyncTrigger() {
  const { isSignedIn } = useAuth()
  const { user } = useUser()

  useEffect(() => {
    if (!isSignedIn || !user) return

    // Silent Background Sync
    // We use sessionStorage to ensure we ONLY hit the sync action once per browser session
    // This maintains "Professionalism" (no redirects) while ensuring data hits Sanity.
    const syncFlag = `wp_synced_${user.id}`
    const isSyncedThisSession = sessionStorage.getItem(syncFlag)

    if (!isSyncedThisSession) {
      const fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Anonymous Member'
      const email = user.emailAddresses[0]?.emailAddress || ''

      const triggerSync = async () => {
        try {
          await syncClerkUserWithSanity(user.id, { fullName, email })
          sessionStorage.setItem(syncFlag, 'true')
        } catch (error) {
          console.error('[Bureau Sync] Silent trigger failed:', error)
        }
      }

      triggerSync()
    }
  }, [isSignedIn, user])

  return null // This component is invisible
}
